import { gql } from "@apollo/client";

export const GetCompanies = gql`
  query GetCompanies(
    $token: String!
    $after: Cursor
    $first: Int
    $customerID: ID!
    $empID: ID!
    $orderBy: AtsCompanyOrder
    $name: String
  ) {
    GetCompanies(
      token: $token
      after: $after
      customerID: $customerID
      empID: $empID
      first: $first
      orderBy: $orderBy
      where: { or: [{ nameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          name
          address
          place
          state
          pin
          country
          contactPerson
          contactPersonDesign
          contactPersonEmail
          contactPersonMobile
          email
          mobile
          url
          logoFilename
          isActive
          panNo
          gstNo
          tanNo
          vatNo
          oth1No
          oth2No
          latitude
          longitude
          timeZone
          customerID
          enableGst
          enableTds
          enableTcs
          regType
          gstState
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

//By Ids

export const GetCompanyNodeById = gql`
  query GetCompanyNodeById($id: ID!, $token: String!) {
    node(id: $id, token: $token) {
      id
      ... on AtsCompany {
        name
        address
        place
        state
        pin
        country
        contactPerson
        contactPersonDesign
        contactPersonEmail
        contactPersonMobile
        email
        mobile
        telephone
        url
        logoFilename
        isActive
        panNo
        regType
        gstState
        gstNo
        tanNo
        vatNo
        oth1No
        oth2No
        enableGst
        enableTds
        enableTcs
        latitude
        longitude
        timeZone
        customerID
        icon
      }
    }
  }
`;

export const GetNotAllocatedIds = gql`
  query GetNotAllocatedIds(
    $token: String!
    $customerID: ID!
    $companyID: ID!
    $table: TableType!
    $table_id: ID!
  ) {
    GetNotAllocatedIds(
      token: $token
      customerID: $customerID
      companyID: $companyID
      table: $table
      table_id: $table_id
    ) {
      companyID
      subsidiaryID
      siteID
      junctionID
    }
  }
`;

export const ExportCompanyTemplate = gql`
  query ExportCompanyTemplate($token: String!, $customerID: ID!) {
    ExportCompanyTemplate(token: $token, customerID: $customerID)
  }
`;
